import { IconButton } from "@mui/material";
import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  color: "#475467",
  lineHeight: "24px",
}));

export const TooltipContentWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const InfoTitle = styled("span")(() => ({
  color: colors.gray800,
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const InfoText = styled("span")(() => ({
  font: "400 14px Manrope",
  color: colors.gray600,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const InfoContainer = styled("div")(() => ({
  display: "flex",
  padding: "8px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "6px",

  "&:hover": {
    background: "rgba(0, 85, 164, 0.12)",
    cursor: "pointer",
  },
}));

export const RemoveIcon = styled(IconButton)(() => ({
  padding: "8px !important",
  "&:hover": {
    backgroundColor: `${colors.error500}08 !important`,
  },

  "&:active": {
    backgroundColor: `${colors.error500}12 !important`,
  },

  "> .MuiTouchRipple-root span": {
    backgroundColor: `${colors.error500}12 !important`,
  },
}));

export const CardContainerTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const StorageBoxOption = styled("div")(() => ({
  font: "400 16px Manrope",
  color: colors.gray600,
  display: "flex",
  flexDirection: "column",
}));

export const StorageBoxOptionNumber = styled("span")(() => ({
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const StorageBoxOptionType = styled("span")(() => ({
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: colors.gray500,
}));

export const DisabledWhereOption = styled("div")(() => ({
  cursor: "not-allowed",
}));

export const SingleUseInfoBox = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-end",
  borderRadius: "8px",
  background: colors.gray100,
}));

export const IconContainer = styled("div")(() => ({
  display: "flex",
  padding: "12px 0px 12px 12px",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

export const TextContainer = styled("div")(() => ({
  display: "flex",
  maxWidth: "230px",
  padding: "12px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  alignSelf: "stretch",
}));
